import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="block text-center font-display text-3xl font-black uppercase text-white mb-8">
          The <span className="text-[#a855f7]">Pooh Sheet</span>
        </Link>
        <div className="card-surface rounded-xl p-8">
          <h1 className="font-display text-2xl font-bold uppercase text-white">Forgot password</h1>
          <p className="text-neutral-500 text-sm mt-1">Enter your email and we'll generate a reset link.</p>
          {result ? (
            <div className="mt-6 space-y-4">
              <div className="border border-[#22c55e]/40 bg-[#22c55e]/10 text-[#22c55e] rounded-lg px-4 py-3 text-sm" data-testid="forgot-success">
                {result.message}
              </div>
              <p className="text-neutral-500 text-xs">
                For security, reset links are not shown here. The site owner can generate your reset link from the admin desk.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-xs uppercase tracking-wider text-neutral-400 font-semibold">Email</label>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                  className="mt-1 w-full bg-[#0a0a0a] border border-white/15 focus:border-[#a855f7] rounded px-3 py-2.5 text-white text-sm outline-none transition-colors duration-200" />
              </div>
              {error && <div className="text-red-400 text-sm" data-testid="forgot-error">{error}</div>}
              <button type="submit" disabled={busy} data-testid="forgot-submit-btn"
                className="w-full bg-[#a855f7] hover:bg-[#9333ea] disabled:opacity-50 text-black font-bold uppercase tracking-wider py-3 rounded transition-colors duration-200">
                {busy ? "Generating..." : "Get reset link"}
              </button>
            </form>
          )}
          <p className="text-sm text-neutral-500 mt-5 text-center">
            <Link to="/login" data-testid="forgot-goto-login" className="text-[#a855f7] hover:underline">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
